import { useNavigate, useParams } from 'react-router-dom';

import { Skeleton } from '@/components/ui/skeleton';
import { splitHours } from '@/lib/hours';
import { StaffInvoiceForm } from '../components/StaffInvoiceForm';
import { useCreateStaffInvoice, useStaffInvoice, useUpdateStaffInvoice } from '../queries';

export function StaffInvoiceFormPage() {
  const { publicId } = useParams();
  const navigate = useNavigate();
  const isEdit = Boolean(publicId);

  const { data: inv, isPending } = useStaffInvoice(publicId ?? '');
  const create = useCreateStaffInvoice();
  const update = useUpdateStaffInvoice(publicId ?? '');

  if (isEdit && isPending) return <Skeleton className="h-96 w-full max-w-2xl" />;

  return (
    <div className="max-w-2xl space-y-6">
      <h1 className="text-2xl font-semibold tracking-tight">
        {isEdit ? 'Edit staff invoice' : 'New staff invoice'}
      </h1>
      <StaffInvoiceForm
        submitLabel={isEdit ? 'Save changes' : 'Create invoice'}
        defaultValues={
          isEdit && inv
            ? {
                employee: String(inv.employee),
                number: inv.number,
                service_description: inv.service_description,
                period_start: inv.period_start,
                period_end: inv.period_end,
                ...splitHours(inv.hours_worked),
                hourly_rate: inv.hourly_rate,
                amount: inv.amount ?? '',
                tax_rate: inv.tax_rate ?? '',
                currency: inv.currency ?? 'USD',
                due_date: inv.due_date ?? '',
                notes: inv.notes,
              }
            : undefined
        }
        onSubmit={async (input) => {
          if (isEdit) {
            await update.mutateAsync(input);
            navigate(`/finance/staff-invoices/${publicId}`);
          } else {
            const created = await create.mutateAsync(input);
            navigate(`/finance/staff-invoices/${created.public_id}`);
          }
        }}
        onCancel={() => navigate('/finance/staff-invoices')}
      />
    </div>
  );
}
